import React, { Suspense, lazy } from "react";
import "./App.css";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";

import Loader from "./Util/Loader/Loader";
import ReactGA from "react-ga4";

// import Error from "./Util/Error/Error";

const Home = lazy(() => import(/* webpackChunkName: "Home"*/ "./Home/Home"));
const ResetMpin = lazy(() =>
  import(/* webpackChunkName: "ResetMpin"*/ "./ResetMpin/ResetMpin")
);

const Dashboard = lazy(() =>
  import(/* webpackChunkName: "Dashboard"*/ "./Dashboard/Dashboard")
);

const Recharge = lazy(() =>
  import(/* webpackChunkName: "Recharge"*/ "./Recharge/Recharge")
);

const ScanPay = lazy(() =>
  import(/* webpackChunkName: "ScanPay"*/ "./ScanPay/ScanPay")
);

const PaySuccess = lazy(() =>
  import(/* webpackChunkName: "PaySuccess"*/ "./PaymentPages/PaySuccess")
);

const PayFailure = lazy(() =>
  import(/* webpackChunkName: "PayFailure"*/ "./PaymentPages/PayFailure")
);

const History = lazy(() =>
  import(/* webpackChunkName: "History"*/ "./History/History.js")
);

const PendingCashback = lazy(() =>
  import(
    /* webpackChunkName: "PendingCashback"*/ "./PendingCashback/PendingCashback.js"
  )
);

const FailedRecharges = lazy(() =>
  import(
    /* webpackChunkName: "FailedRecharges"*/ "./FailedRecharges/FailedRecharges.js"
  )
);

const TermsConditions = lazy(() =>
  import(
    /* webpackChunkName: "TermsConditions"*/ "./PolicyPages/TermsConditions.js"
  )
);

const PrivacyPolicy = lazy(() =>
  import(
    /* webpackChunkName: "PrivacyPolicy"*/ "./PolicyPages/PrivacyPolicy.js"
  )
);

const DeleteAccount = lazy(() =>
  import(
    /* webpackChunkName: "DeleteAccount"*/ "./DeleteAccount/DeleteAccount.js"
  )
);

const theme = createTheme({
  palette: {
    primary: {
      main: "#141414",
    },
    secondary: {
      main: "#34E89E",
    },
  },
});

// | 10590425061
// GTag measurement ID

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.customHistory = createBrowserHistory();
  }

  componentDidMount() {
    ReactGA.initialize("G-SQ765JCYVD");
  }

  render = () => {
    return (
      <ThemeProvider theme={theme}>
        <Router history={this.customHistory}>
          <Suspense
            fallback={
              <div className="loader-container">
                <Loader />
              </div>
            }
          >
            {/* <Header history={this.customHistory} /> */}
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/reset-mpin" component={ResetMpin} />
              <Route path="/recharge" component={Recharge} />
              <Route path="/scan-pay" component={ScanPay} />
              <Route path="/pay-success" component={PaySuccess} />
              <Route path="/pay-failed" component={PayFailure} />
              <Route path="/history" component={History} />
              <Route path="/pending" component={PendingCashback} />
              <Route path="/terms-and-conditions" component={TermsConditions} />
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route path="/delete-account" component={DeleteAccount} />
              <Route oath="/failed-recharges" component={FailedRecharges} />
              {/* 404 Route */}
              <Route component={Home} />
            </Switch>
          </Suspense>
        </Router>
      </ThemeProvider>
    );
  };
}

export default App;
